import { render, staticRenderFns } from "./SignatureEditDocument.vue?vue&type=template&id=79570c0e&scoped=true&"
import script from "./SignatureEditDocument.vue?vue&type=script&lang=js&"
export * from "./SignatureEditDocument.vue?vue&type=script&lang=js&"
import style0 from "./SignatureEditDocument.vue?vue&type=style&index=0&id=79570c0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79570c0e",
  null
  
)

export default component.exports